import Vue from 'vue';
import axios from 'axios';

const CancelToken = axios.CancelToken;
// примесь для компонентов
export const requestsCanceller  = {
  data() {
    return {
      сancelableRequests: {}
    };
  },
  created() {
    this.$store.commit('addComponentWithCancelableRequests',
      this._uid);
    this.сancelableRequests =
      this.$store.state.requestCancellers[this._uid];
  },
  beforeDestroy() {
    this.$store.commit('removeComponentWithCancelableRequests',
      this._uid);
  },
  methods: {
    initCancelableRequests(requestNames) {
      this.$store.commit('initCancelableRequests', {
        component: this._uid,
        requests: requestNames
      });
    },
    createCanceller(requestName) {
      return new CancelToken((canceller) => {
        this.$store.commit('setCanceller', {
          component: this._uid,
          request: {
            name: requestName,
            canceller
          }
        });
      });
    },
    removeCanceller(requestName) {
      this.$store.commit('removeCanceller', {
        component: this._uid,
        request: requestName
      });
    },
    cancelRequest(requestName) {
      this.$store.dispatch('cancelRequest', {
        component: this._uid,
        request: requestName
      });
    },
    wrapInCanceling(requestName, requestFunction) {
      return (...args) => {
        this.cancelRequest(requestName);
        setTimeout(() => { requestFunction(...args); });
      }
    },
    requestErrorIsCancel: axios.isCancel
  }
};

Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/api',
  timeout: 60000,
});

Vue.prototype.$http.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response.status === 403) {
    localStorage.removeItem("RobohomeDataAccessToken");
    window.location.href = '/';
  }
  return error;
});
